import React from 'react';
import Page from '../core/screens/Page';
import Grid from '../responsive/Grid';
import Button from '../ui/Button';
import { ArrowRight } from '../ui/Vectors';

import '../css/screens/HackathonPage.scss';
import ContentBuilder from '../core/ContentBuilder';

export default class HackathonPage extends Page {

	render() {
		return this.wrap(
			<React.Fragment>
				<div className="header padding">
					<Grid cols={2} breakpoints={{small: {cols: 4}}}>
						<h1>{this.props.content.title}</h1>
					</Grid>
					<Grid cols={2} breakpoints={{small: {cols: 4}}}>
						<div className='text'>{this.props.content.text}</div>
					</Grid>
				</div>
				<Grid cols={3} skip={1} breakpoints={{small: {cols: 4, skip: 0}}}>
					<div className="padding">
						<div className='text'>{this.props.content.description}</div>
					</div>
					<img alt={this.props.content.image.src} src={this.props.content.image.src} width={this.props.content.image.width} height={this.props.content.image.height} />
					<div className='padding instructions'>
						{ContentBuilder.build(this.props.content.instructions)}
					</div>
				</Grid>
			</React.Fragment>
		);
	}
}